export const getHaulAwayCharges = (invoice = {}) => {
  const rawRate = Number(invoice.haulAwayFee)
  const rate = Number.isFinite(rawRate) && rawRate > 0 ? rawRate : 0
  const enabled = invoice.haulAway !== false && rate > 0
  const rawQuantity = Number(invoice.haulAwayQuantity)
  const quantity = Number.isFinite(rawQuantity) && rawQuantity > 0 ? rawQuantity : 1
  const rawCost = invoice.haulAwayCost
  const parsedCost = Number(rawCost)
  const cost = rawCost !== undefined && rawCost !== null && rawCost !== '' && Number.isFinite(parsedCost) && parsedCost >= 0 ? parsedCost : rate
  return { rate, cost, quantity, enabled, priceTotal: enabled ? rate * quantity : 0, costTotal: enabled ? cost * quantity : 0 }
}
